import { ClientDetailsData } from "./components/ClientDetailsForm";
import { PostClient } from "./types";

export function clientDetailsDataToClient(
  clientData?: ClientDetailsData
): PostClient | undefined {
  if (!clientData) return undefined;
  const client: PostClient = {
    name: clientData.name ?? undefined,
    zipCode: clientData.zipCode ?? undefined,
    cnpj: clientData.cnpj ?? undefined,
    street: clientData.street ?? undefined,
    streetNumber: clientData.streetNumber ?? undefined,
    complement: clientData.complement ?? undefined,
    city: clientData.city ?? undefined,
    state: clientData.state ?? undefined,
  };
  return client;
}
export function clientToClientDetailsData(
  client: PostClient | null
): ClientDetailsData | undefined {
  if (!client) return undefined;
  const clientDetailsData: ClientDetailsData = {
    name: client.name,
    zipCode: client.zipCode,
    cnpj: client.cnpj,
    street: client.street,
    streetNumber: client.streetNumber,
    complement: client.complement,
    city: client.city,
    state: client.state,
  };
  return clientDetailsData;
}
